import { useEffect } from "gridjs";
import { useState } from "react";
import { Trans } from "react-i18next";
import { FileStatus } from "../../type/FileStatusType";
import AdminPopUp from "./AdminPopUp";
import SectionLoader from "../SectionLoader";

interface UploadInProgressType {
  userId: string;
  fileDetails: File | null;
  changeFileStatus: (fileStatus: FileStatus) => void;
  bulkJobDetails: any;
}

const UploadInProgress = ({
  changeFileStatus,
  fileDetails,
  userId,
  bulkJobDetails,
}: UploadInProgressType) => {
  const [showCancelModal, setCancelModal] = useState(false);

  const cancelUpload = () => {
    setCancelModal(false);
    changeFileStatus(FileStatus.INIT);
  };
  return (
    <>
      <div
        className="inProgressFileTitle"
        data-testid="inProgressFileTitleTest"
      >
        {userId} {fileDetails?.name}
      </div>
      <div className="inProgressTile">
        <Trans i18nKey={"uploading_in_progress"} />
      </div>
      <SectionLoader />
      <AdminPopUp
        show={showCancelModal}
        handelClose={() => {
          setCancelModal(false);
        }}
        handleOnSubmit={() => cancelUpload()}
        title_key="cancel_upload"
        body={
          <>
            <Trans i18nKey={"confirm_cancel"} />
          </>
        }
        primaryButtonTitle_key="yes"
        secondaryButtonTitle_key="no"
      />
    </>
  );
};

export default UploadInProgress;
